/**
 * Modelo de dominio: Unidad Administrativa.
 * 
 * Representa una unidad administrativa activa del sistema.
 * 
 * @legacy FilterProgramarServiciosViewImpl.java (buscador Unidad Administrativa)
 * @table TPSC_UNS_ADMINISTRATIVAS
 * @author Sura - Migración GWT a Spring Boot
 */
export interface UnidadAdministrativa {
  /**
   * Código único de la unidad (PK).
   * Campo: NMCONSECUTIVO
   */
  nmconsecutivo: number;

  /**
   * Código de la unidad administrativa.
   * Campo: CDUNIDAD_ADMINISTRATIVA
   */
  cdunidadAdministrativa: string;

  /**
   * Descripción/nombre de la unidad administrativa.
   * Campo: DSUNIDAD_ADMINISTRATIVA
   */
  dsunidadAdministrativa: string;

  /**
   * Indicador de activo (S/N).
   * Campo: SNACTIVO
   */
  snactivo?: string;
}

/**
 * Filtro para búsqueda de unidades administrativas.
 */
export interface UnidadAdministrativaFiltro {
  /** Código de la unidad (búsqueda parcial) */
  codigo?: string;

  /** Nombre/descripción de la unidad (búsqueda parcial) */
  nombre?: string;

  /** Legacy: filtra por aseguradora/cliente activo — solo unidades vinculadas al cliente */
  nmconsecutivoCliente?: number;
}

/**
 * Respuesta paginada de unidades administrativas (keyset/cursor pagination —
 * ver skill acceso-datos-oracle §7. El backend ya no acepta offset/page).
 */
export interface UnidadAdministrativaPageResponse {
  /** Lista de unidades administrativas */
  content: UnidadAdministrativa[];

  /** Total de elementos */
  totalElements: number;

  /** Cursor para solicitar la página siguiente (null si no hay más) */
  nextCursor: string | null;

  /** Cursor para solicitar la página anterior (null si ya es la primera) */
  previousCursor: string | null;

  /** Indica si hay página siguiente */
  hasNext: boolean;

  /** Indica si hay página anterior */
  hasPrevious: boolean;
}

/**
 * Obtiene el nombre para mostrar de una unidad administrativa.
 */
export function getUnidadAdministrativaNombreDisplay(unidad: UnidadAdministrativa): string {
  return unidad.dsunidadAdministrativa || unidad.cdunidadAdministrativa || '';
}
